import { Component } from '@angular/core';
import { NxIconComponent } from '@allianz/ng-aquila/icon';
import { TextPipe } from '@ps20-frontend/text-service';

@Component({
  selector: 'ps20-shop-constructionpage',
  templateUrl: './constructionpage.component.html',
  imports: [NxIconComponent, TextPipe],
})
export class ConstructionpageComponent {}
